import { ACTIVITY_REQUEST, ACTIVITY_SUCCESS, ACTIVITY_ERROR } from "../../actions/activityLogAction";

const initialState = { datas: null, loading: false, error: null, requestId: null };
export default function activityLogReducer(state = initialState, action) {
  if (action.type === ACTIVITY_REQUEST) return { ...state, datas: null, loading: true, error: null, requestId: action.requestId };
  if (action.requestId !== state.requestId) return state;
  if (action.type === ACTIVITY_SUCCESS) return { ...state, datas: action.data, loading: false, error: null };
  if (action.type === ACTIVITY_ERROR) return { ...state, datas: null, loading: false, error: action.error };
  return state;
}
